import { render, staticRenderFns } from "./EagleBox.vue?vue&type=template&id=2f6b6bb0&scoped=true"
import script from "./EagleBox.vue?vue&type=script&lang=js"
export * from "./EagleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b6bb0",
  null
  
)

export default component.exports